<p-dialog #dialog [visible]="showDialog" (visibleChange)="changeVisibleDialog($event)" [modal]="true" [transitionOptions]="transitionOptions" [styleClass]="(title === '' ? 'small-header ' : '') + size + '-modal-width ' + (hasScroll ? '' : 'has-fixed-height-content ') + (hasFullHeight ? 'has-full-height-content ' : '') + (hasFooter ? '' : 'no-footer ') + (isDrawer ? 'app-dialog-drawer' : '')" appendTo="body" [position]="isDrawer ? dialogPosition.RIGHT : position" [resizable]="false" [closable]="false" [draggable]="!isDrawer && position === dialogPosition.CENTER">
  <ng-template pTemplate="header">
    <div class="w-100 flex flex-column gap-16">
      <div class="w-100 flex align-items-center justify-content-between">
        <span class="p-dialog-title">{{ title }}</span>
        <div class="p-dialog-header-icons">
          <button *ngIf="isMaximizable && !isDrawer" type="button" class="p-dialog-header-icon p-link" (click)="toggleMaximize(dialog)">
            <i class="pi" [ngClass]="{ 'pi-window-maximize': !isMaximized, 'pi-window-minimize': isMaximized }"></i>
          </button>
          <button *ngIf="isClosable" type="button" class="p-dialog-header-icon p-link" (click)="changeHideDialog()">
            <i class="pi pi-times"></i>
          </button>
        </div>
      </div>
      <div *ngIf="headerContent" class="w-100">
        <ng-content select="[header]"></ng-content>
      </div>
    </div>
  </ng-template>
  <ng-content></ng-content>
  <ng-template pTemplate="footer">
    <ng-content select="[footer]"></ng-content>
    <div *ngIf="!isLockActions" class="footer-container">
      <app-button *ngIf="isClosable && showCancelButton" label="Cancelar" [variant]="buttonVariant.LINK" [color]="buttonColor.NEUTRAL_LIGHT" [callback]="callbackHideDialog" [hasIcon]="false"></app-button> <ng-content select="[footerButtons]"></ng-content>
      <app-button *ngIf="showConfirmButton" [icon]="iconConfirmButton" [disabled]="disabledConfirmButton" [label]="labelConfirmButton" [callback]="callbackConfirmButton"></app-button>
    </div>
  </ng-template>
</p-dialog>
